export default __webpack_public_path__ + "static/media/screen_google_calendar_10.2bf03fad.png";